module.exports = __webpack_public_path__ + "img/Einzeldiagnose_Rechnung_Clara.8840e2ff.png";